<template>
  <div>
    <slot name="botao" :callbackExclusao="excluirProdutoDoPedido">
      <v-btn :disabled="data_table_departamentos_carregando_dados" icon @click="excluirProdutoDoPedido">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </slot>
  </div>
</template>

<script>
import {excluirCategoriaDoPedido} from "../../../../../../api/compras/MateriaPrima.js";
import {logout} from "../../../../../../helpers";
import {data_table_departamentos_carregando_dados} from "../../../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";

export default {
  name: "ExcluirCategorias",
  mixins: [data_table_departamentos_carregando_dados],
  props: {
    categorias: {
      type: Array,
      required: true
    }
  },
  methods: {
    excluirProdutoDoPedido() {
      const categorias = this.Helpers.arrayColumn(this.categorias, ['idcategoria', 'id_pedido']);

      this.$store.dispatch("loading/addRequisicao",
        excluirCategoriaDoPedido({categorias})
          .then(this.sucessoExclusao)
          .catch(logout)
      )
    },
    sucessoExclusao() {
      this.$emit('produto-excluido-carrinho', {});
    }
  }
}
</script>

<style scoped>

</style>
